import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaDivider from './VaDivider.vue'

export default withConfigTransport(VaDivider)
